import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environmentEmpleados } from '@environments/environment';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FormsService {

  constructor(private http: HttpClient) { }

  getUnbillableResquestType() {
    return this.http.get<any>(`${environmentEmpleados.apiUrl}/UnbillableRequestType`);
  }

  getTemporaryAbsenceReason() {
    return this.http.get<any>(`${environmentEmpleados.apiUrl}/TemporaryAbsenceReason`)
  }

  getTeleworkerDutyItem() {
    return this.http.get<any>(`${environmentEmpleados.apiUrl}/TeleworkerDutyItem`)
  }

  getQuestionSecurity() {
    return this.http.get<any>(`${environmentEmpleados.apiUrl}/SecurityForm/GetQuestionGroupByQuestionType`)
  }

  postDressCode(form: any) {

    console.log("form dress", form)
    return this.http.post<any>(`${environmentEmpleados.apiUrl}/DressCode/CurrentUser`, form);
  }

  postDressCodePreview(form: any) {

    //  let json = JSON.stringify(form)

    console.log("form dress preview", form)
    return this.http.post<any>(`${environmentEmpleados.apiUrl}/DressCode/CurrentUserGetPdfPreview`, form);
  }

  postMobileUseRequest(form: any) {
    console.log("form Mobile Use Request", form)
    return this.http.post<any>(`${environmentEmpleados.apiUrl}/MobileUseRequest/CurrentUser`, form);
  }

  postMobileUseRequestPreview(form: any) {
    console.log("form Mobile Use Request preview", form)
    return this.http.post<any>(`${environmentEmpleados.apiUrl}/MobileUseRequest/CurrentUserGetPdfPreview`, form);
  }

  postUnbillableRequest(form: any) {
    console.log("Form unbi", form)
    return this.http.post<any>(`${environmentEmpleados.apiUrl}/UnbillableRequest/CurrentUser`, form)

  }

  postUnbillableRequestPreview(form: any) {

    //  let json = JSON.stringify(form)

    console.log("form Unbi preview", form)
    return this.http.post<any>(`${environmentEmpleados.apiUrl}/UnbillableRequest/CurrentUserGetPdfPreview`, form);
  }

  postExpenseReim(form: any) {
    console.log("Form er", form)
    return this.http.post<any>(`${environmentEmpleados.apiUrl}/ExpensiveReimbursement/CurrentUser`, form)
  }

  postExpenseReimPreview(form: any) {
    console.log("Form er", form)
    return this.http.post<any>(`${environmentEmpleados.apiUrl}/ExpensiveReimbursement/CurrentUserGetPdfPreview`, form)
  }

  postExtraHours(form: any) {
    console.log("Form eh", form)
    return this.http.post<any>(`${environmentEmpleados.apiUrl}/ExtraHours/CurrentUser`, form)
  }

  postExtraHoursPreview(form: any) {
    console.log("Form eh", form)
    return this.http.post<any>(`${environmentEmpleados.apiUrl}/ExtraHours/CurrentUserGetPdfPreview`, form)
  }

  postTemporaryAbsence(form: any) {
    console.log("Form ta", form)
    return this.http.post<any>(`${environmentEmpleados.apiUrl}/TemporaryAbsence/CurrentUser`, form)
  }

  postTemporaryAbsencePreview(form: any) {
    console.log("Form ta preview", form)
    return this.http.post<any>(`${environmentEmpleados.apiUrl}/TemporaryAbsence/CurrentUserGetPdfPreview`, form)
  }

  //Compensación horas extras 
  postMakeupOvertime(form: any) {
    console.log("Form mo", form)
    return this.http.post<any>(`${environmentEmpleados.apiUrl}/MakeUpOvertime/CurrentUser`, form)
  }

  //Compensación horas extras 
  postMakeupOvertimePreview(form: any) {
    console.log("Form mo Preview", form)
    return this.http.post<any>(`${environmentEmpleados.apiUrl}/MakeUpOvertime/CurrentUserGetPdfPreview`, form)
  }

  //Programa de teletrabajo 
  postTelecommuting(form: any) {
    console.log("Form mo", form)
    return this.http.post<any>(`${environmentEmpleados.apiUrl}/Telecommuting/CurrentUser`, form)

  }

  //Deberes de los teletrabajadores
  postTeleWorkerDuty(form: any) {
    console.log("Form mo", form)
    return this.http.post<any>(`${environmentEmpleados.apiUrl}/TeleworkerDuty/CurrentUser`, form)

  }

  //Formulario de seguridad
  postSecurityForm(form: any) {
    console.log("Form mo", form)
    return this.http.post<any>(`${environmentEmpleados.apiUrl}/SecurityForm/CurrentUser`, form)

  }

  getCurrentUserForm(){
    return this.http.get<any>(`${environmentEmpleados.apiUrl}/Form/GetByCurrentUser`);
  }

  //GET DE FORMULARIOS

  getDressCode(ID: any) {

    console.log("form get dress", ID)
    return this.http.get<any>(`${environmentEmpleados.apiUrl}/DressCode/CurrentUserGetPdfById/${ID}`);
  }

  getUnbillableCode(ID: any) {

    console.log("form get dress", ID)
    return this.http.get<any>(`${environmentEmpleados.apiUrl}/UnbillableRequest/CurrentUserGetPdfById/${ID}`);
  }

  ExpensiveReimbursement(ID: any) {

    console.log("form e r", ID)
    return this.http.get<any>(`${environmentEmpleados.apiUrl}/ExpensiveReimbursement/CurrentUserGetPdfById/${ID}`);
  }

  MobileUseRequest(ID: any) {

    console.log("form get dress", ID)
    return this.http.get<any>(`${environmentEmpleados.apiUrl}/MobileUseRequest/CurrentUserGetPdfById/${ID}`);
  }




}
